import axios from "axios";
import {url_local} from '../url'
//import state from "../../store";
import state from '../../store/index'



export function GetEnterprise() {
    //console.log(state.state.currentUser.access_token);
    const config = {
        headers : {
            'Content-Type' : 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: "Bearer " +state.state.currentUser.access_token
        }
    }

    return new Promise((res, rej) => {
        axios.get(`${url_local}enterprise`, config).then(response => {
            res(response.data);
        })
        .catch(err => {
            rej("error al obtener las empresas: " + err);
        });
    });
}

export function SubirEnterprise(form) {
    //console.log(state.state.currentUser.access_token);
    const config = {
        headers : {
            'Content-Type' : 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: "Bearer " +state.state.currentUser.access_token
        }
    }

    return new Promise((res, rej) => {
        axios.post(`${url_local}enterprise`,form ,config).then(response => {
            res(response.data);
        })
        .catch(err => {
            rej("error al subir la empresa: " + err);
        });
    });
}

export function EditEnterprise(id,form) {
    //console.log(state.state.currentUser.access_token);
    const config = {
        headers : {
            'Content-Type' : 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: "Bearer " +state.state.currentUser.access_token
        }
    }

    return new Promise((res, rej) => {
        axios.put(`${url_local}enterprise/${id}`,form ,config).then(response => {
            res(response.data);
        })
        .catch(err => {
            rej("error al editar la empresa: " + err);
        });
    });
}

export function DeleteEnterprise(id) {
    //console.log(state.state.currentUser.access_token);
    const config = {
        headers : {
            'Content-Type' : 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: "Bearer " +state.state.currentUser.access_token
        }
    }

    return new Promise((res, rej) => {
        axios.delete(`${url_local}enterprise/${id}` ,config).then(response => {
            res(response.data);
        })
        .catch(err => {
            rej("error al eliminar la empresa: " + err);
        });
    });
}





  

